<template lang="html">
  <v-dialog v-model="visible" persistent max-width="440">
    <Loading :flat="true" />
  </v-dialog>
</template>

<script>
  export default {
    props: {
      visible: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/apps/bpm/superMonitor/components/utils/LoadingModal.vue